'use strict';

// monkey-patches $templateCache to have a getKeys() method
// https://github.com/angular/angular.js/pull/3760#issuecomment-130343142
angular.module('tcApp').config(['$provide', function($provide) {
	$provide.decorator('$templateCache', ['$delegate', function($delegate) {
										var keys = [];
										var origPut = $delegate.put;
										var origRemove = $delegate.remove;

										$delegate.put = function(key, value) {
													var keyIndex = keys.indexOf(key);
													if (keyIndex === -1) {
														keys.push(key);
													}
													return origPut(key, value);
												};
										$delegate.remove = function(key) {
											var keyIndex = keys.indexOf(key);
											if (keyIndex !== -1) keys.splice(keyIndex, 1);
											return origRemove(key);
										};

										// we would need cache.peek() to get all keys from $templateCache, but this features was never
										// integrated into Angular: https://github.com/angular/angular.js/pull/3760
										$delegate.getKeys = function() {
													return keys;
												};

										return $delegate;
									}]);
}]);
